import './blocks/restricted-pages-list';
import './blocks/restrict-section';
